import React from 'react';

interface FlaskLoaderProps {
    text?: string;
    size?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
}

const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
};

export const FlaskLoader: React.FC<FlaskLoaderProps> = ({
    text,
    size = 'md',
    className = ''
}) => {
    return (
        <div className={`flex flex-col items-center justify-center gap-4 ${className}`}>
            <div className={`relative ${sizeClasses[size]} animate-pulse`}>
                <img
                    src="/assets/flask-only-no-bg.png"
                    alt="Loading..."
                    className="w-full h-full object-contain drop-shadow-[0_0_15px_rgba(255,215,0,0.4)]"
                />
            </div>
            {text && (
                <p className="text-mystic-400 text-sm animate-pulse tracking-wide font-medium">
                    {text}
                </p>
            )}
        </div>
    );
};
